import { KgInsightThemeType } from '@api/api/kg-insights';
import { ThemePerformanceSortHorizon } from '@api/api/theme-overview';
import { useThemePerformanceTimeseries } from '@terminal/react-query-hooks/themes/useThemePerformanceTimeseries';

export const useThemePerformanceChartData = ({
  themeId,
  themeType,
  horizon,
  enabled = true,
}: {
  themeId: string;
  themeType?: KgInsightThemeType;
  horizon: ThemePerformanceSortHorizon;
  enabled?: boolean;
}) => {
  const isFinancialOrMacro = themeType === 'financial' || themeType === 'macro';
  const shouldRequestLongOnly = isFinancialOrMacro;

  const {
    data: primaryChartData,
    isLoading: isPrimaryLoading,
    error: primaryError,
  } = useThemePerformanceTimeseries(
    {
      themeId,
      horizon,
      subClass: shouldRequestLongOnly ? ('long' as const) : undefined,
    },
    enabled
  );

  const shouldUseFallback =
    enabled &&
    shouldRequestLongOnly &&
    !isPrimaryLoading &&
    (primaryChartData?.aggregate.length ?? 0) === 0;

  const {
    data: fallbackChartData,
    isLoading: isFallbackLoading,
    error: fallbackError,
  } = useThemePerformanceTimeseries(
    {
      themeId,
      horizon,
      subClass: undefined,
    },
    shouldUseFallback
  );

  return {
    chartData: shouldUseFallback ? fallbackChartData : primaryChartData,
    isLoading: isPrimaryLoading || (shouldUseFallback && isFallbackLoading),
    error: shouldUseFallback ? fallbackError : primaryError,
    isLongOnly: shouldRequestLongOnly && !shouldUseFallback,
  };
};
